import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';


//-----------------------------------------------------------
const githubUrl = 'https://github.com/mananc12';
const linkedinUrl = 'https://www.linkedin.com/in/manan-rajput-chauhan/';
const instagramUrl = 'https://www.instagram.com/manan_rajput_chauhan/';


const ExternalLink = ({ url, children }) => {
  const handleClick = () => {
    window.open(url, '_blank');
  };

  return (
    <div onClick={handleClick} style={{ cursor: 'pointer' }}>
      {children}
    </div>
  );
};
//-------------------------------------------------------------


//showing animation during screen scrolling

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  section.scrollIntoView({ behavior: 'smooth' });
};

//---------------------------------------------------------------------

const Navbar = () => {

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000); // Simulating a 1-second delay, adjust as needed
  }, []);

  return (
    <div>
      <nav>
        <div className="left logo">
          <img src="images/logo9.png" alt="logo"/>
          {/* <img src="images/logo8.png"/ alt="logo"> */}
        </div>
        <div className="right">
          <ul>
            <div className="section-tab">
            <li>
              <Link className="link" onClick={() => scrollToSection('home')}>
                <p>Home</p>
              </Link>
            </li>
            <li>
              <Link className="link" onClick={() => scrollToSection('second')}>
                <p>About</p>
              </Link>
            </li>
            <li>
              <Link className="link" onClick={() => scrollToSection('contact')}>
               <p> Contact</p>
              </Link>
            </li>
            </div>
            <li>
              <div className="container-connect">

              <Link className="link" onClick={() => scrollToSection('contact')}>
                <div className="lets-connect">
                  <div className="connect"><p>Let's connect</p></div>
                </div>
              </Link>

              <div className="social-icons">
                <ExternalLink className="link" url={githubUrl}>
                  <GitHubIcon className="git icons"/>
                </ExternalLink>
                <ExternalLink className="link" url={linkedinUrl}>
                  <LinkedInIcon className="linkdin icons"/>
                </ExternalLink>
                <ExternalLink className="link" url={instagramUrl}>
                  <InstagramIcon className="insta icons" />
                </ExternalLink>
              </div>
              
              </div>
            </li>

          </ul>
        </div>
      </nav>

      {isLoading ? (
        // Render the loader while the home section is loading
        <div>Loading...</div>
      ) : (
        // Render the home section once it has finished loading
        <div id="home">
          {/* Home section content */}
        </div>
      )}
    </div>
  );
};

export default Navbar;
